/**
 * Plan Badge Component
 * Reusable plan badge with upgrade link
 */

import {Link} from 'react-router-dom';
import {ROUTES} from '../../config/constants';

export function PlanBadge() {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-100 dark:bg-[#2D2D30] text-sm text-textSecondary dark:text-gray-300">
      <span>Free plan</span>
      <span className="text-gray-400 dark:text-gray-500">•</span>
      <Link
        to={ROUTES.STUDY_MODE_PRICING}
        className="underline hover:text-orange-600 dark:hover:text-orange-500 transition-colors"
      >
        Upgrade
      </Link>
    </div>
  );
}

